<template>
  <div class="resume">
    <v-row class="mx-0 py-2 px-4 resume-service">
      <v-col cols="9">
        <h2>{{ vehicleApp.name }}</h2>
        <span class="totals"><b>{{ serviceMonthPrice | formatPrice(currency.symbol) }}</b> {{ $t('service_details.txt.month') }}</span>
      </v-col>
      <v-col cols="3">
        <v-img
          v-if="vehicleApp.iconUrl!==null"
          class="float-right"
          width="38"
          :src="vehicleApp.iconUrl"
        />
      </v-col>
      <v-col
        cols="12"
        class="description"
      >
        <span v-html="vehicleApp.description" />
      </v-col>
    </v-row>
    <v-divider />
    <v-row class="mx-0 py-2 px-4 resume-activated">
      <v-col
        cols="8"
        class="align-self-center"
      >
        <span class="d-flex">{{ $t('service_details.txt.activated_vehicles') }}</span>
      </v-col>
      <v-col cols="4">
        <span class="d-flex justify-end">
          <v-icon class="truck_icon">
            mdi-truck
          </v-icon>
          x <label>{{ totalActiveVehicles }}</label>
        </span>
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      class="mx-0 py-2 px-4 resume-totals"
    >
      <v-col
        cols="12"
        sm="4"
        lg="12"
        xl="4"
        class="align-self-center"
      >
        {{ $t('service_details.txt.total_cost') }}
      </v-col>
      <v-col
        class="text-sm-right text-lg-left text-xl-right align-self-center pt-0 pt-sm-3 pt-lg-0 pt-xl-3"
        cols="12"
        sm="8"
        lg="12"
        xl="8"
      >
        <span
          class="totals"
        >{{ totalMonthly | formatPrice(currency.symbol) }} <label>{{ $t('service_details.txt.month') }} </label></span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'VehicleAppsDetailCard',
  props: {
    vehicleApp: {
      type: Object,
      default: () => ({})
    },
    serviceAnnualPrice: {
      type: Number,
      default: 0
    },
    serviceMonthPrice: {
      type: Number,
      default: 0
    },
    month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    totalActiveVehicles: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      newService: {},
      totalAnnual: 0,
      totalMonth: 0
    }
  },
  computed: {
    ...mapState('account', ['currency']),
    totalYearly() {
      if (!this.year) return this.totalAnnual
      return this.totalAnnual + this.year
    },
    totalMonthly() {
      if (!this.month) return this.totalMonth
      return this.totalMonth + this.month
    }
  },
  async created() {
    await this.getServiceCosts()
  },
  methods: {
    ...mapActions('trucks', ['getTrucksPerService']),
    async getServiceCosts() {
      const id = this.$router.history.current.params.id
      const services = (await this.getTrucksPerService()) || []
      const productService = services.find(service => service.productID === id)
      if (productService) {
        this.totalAnnual = productService.totals.Annual || 0
        this.totalMonth = productService.totals.Month || 0
      }
    }
  }
}
</script>

<style lang="scss">
.resume {
  background-color: var(--v-pale-two-base);

  &-service {
    h2 {
      font-size: 1.25rem;
      font-weight: bold;
      white-space: normal;
      color: var(--v-slate-base);
    }

    .totals {
      font-size: 0.875rem;
      color: var(--v-bluegrey-base);
    }

    .description {
      font-size: 1rem;
      color: var(--v-slate-base);
    }
  }

  &-activated {
    background-color: white;
    color: var(--v-steel-base);
    font-size: 0.875rem;
    span {
      align-items: center;
      .truck_icon {
        color: var(--v-steel-base);
        margin-right: 10px;
      }
      label {
        font-size: 1.125rem;
        font-weight: bold;
        color: var(--v-slate-base);
        margin-left: 10px;
      }
    }
  }

  &-totals {
    background-color: white;
    border-radius: 8px;
    font-size: 0.875rem;
    color: var(--v-steel-base);
    span {
      color: var(--v-slate-base);
      font-size: 1.25rem;
      font-weight: bold;
      label {
        font-size: 0.875rem;
        font-weight: normal;
      }
    }
  }
}
</style>